function filterMegaMenuPromos(scope = document) {
  const promoLists = scope.querySelectorAll('.mega-menu__promo[data-current-menu]');

  promoLists.forEach((list) => {
    const currentMenu = (list.dataset.currentMenu || '').trim();
    const promoItems = Array.from(list.querySelectorAll('.mega-menu__promo-item[data-promo-menu]'));

    let visibleCount = 0;

    promoItems.forEach((promoItem) => {
      const promoMenu = (promoItem.dataset.promoMenu || '').trim();
      const isMatch = promoMenu === currentMenu;

      if (!isMatch) {
        const wrapper = promoItem.closest('.shopify-block') || promoItem;
        wrapper.remove();
      } else {
        visibleCount++;
      }
    });

    const grid = list.closest('.mega-menu__grid');

    if (visibleCount > 0) {
      grid?.classList.add('mega-menu--has-promo');
    } else {
      list.remove();
      grid?.classList.remove('mega-menu--has-promo');
    }
  });
}

function runMegaMenuPromoFilter() {
  filterMegaMenuPromos();
  requestAnimationFrame(() => filterMegaMenuPromos());
  setTimeout(() => filterMegaMenuPromos(), 100);
  setTimeout(() => filterMegaMenuPromos(), 300);
}

document.addEventListener('DOMContentLoaded', runMegaMenuPromoFilter);

// Notify Me overlay — sync label from BIS_trigger and trigger it on click
function syncNotifyMeOverlays() {
  const bisTrigger = document.getElementById('BIS_trigger');
  const overlays = document.querySelectorAll('[data-notify-me-overlay]');
  if (!overlays.length) return;

  const label = bisTrigger?.textContent?.trim() || 'Notify Me';
  overlays.forEach((overlay) => {
    const textEl = overlay.querySelector('.add-to-cart-text__content span span');
    if (textEl) textEl.textContent = label;
  });
}

document.addEventListener('click', function (event) {
  if (!event.target.closest('[data-notify-me-overlay]')) return;
  const bisTrigger = document.getElementById('BIS_trigger');
  if (bisTrigger) bisTrigger.click();
});

document.addEventListener('DOMContentLoaded', function () {
  syncNotifyMeOverlays();

  // For single no-variant products that are sold out, there are no variant:selected /
  // variant:update events — show the overlay immediately on load and hide the skeleton.
  document.querySelectorAll('add-to-cart-component[data-notify-me-active]').forEach((component) => {
    const overlay = component.querySelector('[data-notify-me-overlay]');
    const skeleton = component.querySelector('.atc-skeleton');
    if (overlay) overlay.hidden = false;
    if (skeleton) skeleton.hidden = true;
  });
});

// Re-sync after variant changes re-render the button area
document.addEventListener('theme:variant:update', syncNotifyMeOverlays);
document.addEventListener('variant-selected', syncNotifyMeOverlays);

// Watch for the BIS app injecting or updating #BIS_trigger asynchronously
(function watchBISTrigger() {
  const observer = new MutationObserver(() => {
    const bisTrigger = document.getElementById('BIS_trigger');
    if (bisTrigger) {
      syncNotifyMeOverlays();
      // Once found, switch to a cheaper character-data observer scoped to just that element
      observer.disconnect();
      new MutationObserver(syncNotifyMeOverlays).observe(bisTrigger, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Show/hide the overlay based on variant availability
document.addEventListener('variant:update', function (event) {
  const available = event.detail?.resource?.available;
  const overlays = document.querySelectorAll('[data-notify-me-overlay]');
  overlays.forEach((overlay) => {
    overlay.hidden = !!available;
  });
  if (!available) syncNotifyMeOverlays();

  // Hide skeleton once update resolves
  document.querySelectorAll('.atc-skeleton').forEach((el) => {
    el.hidden = true;
  });
});

// Show skeleton immediately on variant selection (before fetch resolves)
document.addEventListener('variant:selected', function () {
  document.querySelectorAll('.atc-skeleton').forEach((el) => {
    el.hidden = false;
  });
});
document.addEventListener('shopify:section:load', runMegaMenuPromoFilter);
document.addEventListener('shopify:block:select', runMegaMenuPromoFilter);
document.addEventListener('shopify:block:deselect', runMegaMenuPromoFilter);

document.addEventListener(
  'pointerenter',
  (event) => {
    const target = event.target instanceof Element ? event.target : event.target.parentElement;

    if (target && target.closest('.menu-list__list-item')) {
      setTimeout(() => filterMegaMenuPromos(), 50);
    }
  },
  true
);

window.filterMegaMenuPromos = filterMegaMenuPromos;

// PDP selected variant change handler
window.customVariantDropdownTouched = window.customVariantDropdownTouched || {};

function getDropdownKey(dropdown) {
  const optionName = dropdown.dataset.optionName || '';
  const optionPosition = dropdown.dataset.optionPosition || '';
  const productRoot =
    dropdown.closest('[data-product-id]') ||
    document.querySelector('.product-details variant-picker[data-product-id]') ||
    document.querySelector('.product-details product-form-component[data-product-id]');

  const productId =
    productRoot?.getAttribute('data-product-id') ||
    productRoot?.dataset?.productId ||
    'default';

  return `${productId}:${optionPosition}:${optionName}`;
}

function getPlaceholder(dropdown) {
  const optionName = (dropdown.dataset.optionName || 'option').toLowerCase();
  return `Select a ${optionName}`;
}

function syncCustomVariantDropdown(dropdown) {
  if (!dropdown) return;

  const nativeSelect = dropdown.querySelector('.custom-variant-dropdown__native');
  const triggerText = dropdown.querySelector('.custom-variant-dropdown__trigger-text');

  if (!nativeSelect || !triggerText) return;


  const trigger = dropdown.querySelector('.custom-variant-dropdown__trigger');
  const optionNameEl = dropdown.querySelector('.custom-variant-dropdown__trigger-option-name');

  if (trigger && optionNameEl) {
    const optionName = dropdown.dataset.optionName || '';
    optionNameEl.textContent = optionName ? `${optionName}` : '';
  }    

  const key = getDropdownKey(dropdown);
  const touched = window.customVariantDropdownTouched[key] === true;
  const selectedValue = nativeSelect.value || '';
  

  const selectedButton = selectedValue
    ? Array.from(dropdown.querySelectorAll('.custom-variant-dropdown__option')).find(
        (option) => option.dataset.value === selectedValue
      )
    : null;

  const selectedLabel =
    selectedButton?.querySelector('.custom-variant-dropdown__option-label')?.textContent.trim() ||
    selectedValue;

  if (touched && selectedValue) {
    triggerText.textContent = selectedLabel;
    dropdown.classList.remove('is-placeholder');
    dropdown.setAttribute('data-user-selected', 'true');
  } else {
    triggerText.textContent = getPlaceholder(dropdown);
    dropdown.classList.add('is-placeholder');
    dropdown.setAttribute('data-user-selected', 'false');
  }

  dropdown.querySelectorAll('.custom-variant-dropdown__option').forEach((option) => {
    const isSelected = option.dataset.value === selectedValue;
    option.classList.toggle('var-selected', isSelected);
    option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
  });
}

function initCustomVariantDropdowns(scope = document) {
  scope.querySelectorAll('.custom-variant-dropdown').forEach((dropdown) => {
    const nativeSelect = dropdown.querySelector('.custom-variant-dropdown__native');

    if (!nativeSelect) return;

    if (nativeSelect.dataset.customDropdownBound !== 'true') {
      nativeSelect.dataset.customDropdownBound = 'true';

      nativeSelect.addEventListener('change', function () {
        syncCustomVariantDropdown(dropdown);
      });
    }

    syncCustomVariantDropdown(dropdown);
  });
}

document.addEventListener('click', function (event) {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  document.querySelectorAll('.custom-variant-dropdown').forEach((dropdown) => {
    const trigger = dropdown.querySelector('.custom-variant-dropdown__trigger');
    const menu = dropdown.querySelector('.custom-variant-dropdown__menu');
    const nativeSelect = dropdown.querySelector('.custom-variant-dropdown__native');

    if (!trigger || !menu || !nativeSelect) return;

    const clickedTrigger = target.closest('.custom-variant-dropdown__trigger');
    const clickedOption = target.closest('.custom-variant-dropdown__option');

    if (clickedTrigger && dropdown.contains(clickedTrigger)) {
      const isOpen = dropdown.classList.contains('is-open');

      document.querySelectorAll('.custom-variant-dropdown.is-open').forEach((openDropdown) => {
        openDropdown.classList.remove('is-open');

        const openTrigger = openDropdown.querySelector('.custom-variant-dropdown__trigger');
        const openMenu = openDropdown.querySelector('.custom-variant-dropdown__menu');

        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
        if (openMenu) openMenu.hidden = true;
      });

      if (!isOpen) {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }

      return;
    }

    if (clickedOption && dropdown.contains(clickedOption)) {
      if (clickedOption.disabled) return;

      const value = clickedOption.dataset.value;
      if (!value) return;

      const key = getDropdownKey(dropdown);
      window.customVariantDropdownTouched[key] = true;

      nativeSelect.value = value;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));

      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;

      syncCustomVariantDropdown(dropdown);
      return;
    }

    if (!dropdown.contains(target)) {
      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  initCustomVariantDropdowns();
});

document.addEventListener('shopify:section:load', function (event) {
  initCustomVariantDropdowns(event.target instanceof Element ? event.target : document);
});

// button state
window.manualVariantSelection = window.manualVariantSelection || {};

function getProductKey(component) {
  return component?.getAttribute('data-product-id') || 'default';
}

function updateProductButtonState(component) {
  if (!component) return;

  const button = component.querySelector('.product-details .add-cart-variant');
  if (!button) return;

  const productKey = getProductKey(component);
  const hasManualSelection = window.manualVariantSelection[productKey] === true;

  button.classList.toggle('is-disabled', !hasManualSelection);
  button.disabled = !hasManualSelection;
}

function initManualVariantButtons(scope = document) {
  const components = scope.querySelectorAll('.product-details product-form-component[data-product-id]');

  components.forEach((component) => {
    updateProductButtonState(component);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initManualVariantButtons();
});

document.addEventListener('shopify:section:load', function (event) {
  initManualVariantButtons(event.target instanceof Element ? event.target : document);
});

document.addEventListener('click', function (event) {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const optionButton = target.closest('.custom-variant-dropdown__option');
  if (!optionButton) return;

  const component = optionButton.closest('product-information, featured-product-information, quick-add-dialog, section, main')
    ?.querySelector('.product-details product-form-component[data-product-id]');

  if (!component) return;

  const productKey = getProductKey(component);
  window.manualVariantSelection[productKey] = true;

  updateProductButtonState(component);
});

/** AMP Back in Stock - update data-variant-available on variant change for CSS to react **/
document.addEventListener('variant:update', (event) => {
  const available = event.detail?.variant?.available;
  if (available === undefined) return;
  const section = event.target?.closest('[data-testid="product-information"]');
  if (section) {
    section.dataset.variantAvailable = available;
  }
});